import { styled } from '@linaria/react';

export const Container = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
	gap: var(--gap-x4);
`;
